import { featureEnabler } from '@kaltura-ott/tvpil-shared';

const GRID_PAGE_SIZE = 'GRID_PAGE_SIZE';

export const COMPONENT_NAME = 'GridPage';
export const PAGE_SIZE = featureEnabler.variation(GRID_PAGE_SIZE, 50);
